import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { apiService } from '../../../services/apiService';
import { Link, useParams } from 'react-router-dom';
function RaisedCasesSeekerComp() {

    const permissionData = JSON.parse(localStorage.getItem('permissions'));
    const [loading, setLoading] = useState(true);
    const [caseData, setCaseData] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        if(id){
            const fetchAll = async () => {
                setLoading(true);
                try {
                    await Promise.all([
                        apiService.getRequest(`admin/jobseeker/my-rised-cases/${id}`).then(res => {
                            if (res?.success === true) setCaseData(res.data);
                            else if (res?.authenticate === false) handleLogout();
                        }),
                    ]);
                } catch (error) {
                    console.error('Error fetching dashboard data:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchAll();
        }
    }, [id]);

    // Extracted logout helper to avoid repetition
    const handleLogout = async () => {
        await apiService.postRequest('/auth/logout');
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
    };

  return (
    <div>
        {loading ? 
            <div className='d-flex justify-content-center w-100'>
                <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :<>
            <Grid size={{xs:12}} container className="mt-4" alignContent="flex-start">
                <Grid size={{xs:12}} container className="border_recentdashboard h-100 py-3" alignContent="flex-start">
                <h5 className='fw-semibold'>Raised Cases</h5>
                    {caseData && caseData.length > 0 ? (
                        caseData && caseData.map((casedata, index) => (
                        <Grid size={{xs:12}} key={index} container alignItems="center" className="py-2 main_casepend_dash">
                            <img src={require('../../../assets/circleprocess.svg').default} alt="" />
                            <span className='fw-medium'>
                                {casedata.case_task_link && permissionData && permissionData?.manage_my_tasks === true ? 
                                <Link className='task_viewlink me-4' target="_blank" style={{width:"max-content"}} to={casedata.case_task_link || "/task/raised-cases"}>{casedata.format_id}</Link>:
                                <small className='task_viewlink fs-6 me-4' style={{width:"max-content"}}>{casedata.format_id}</small>}
                                {casedata?.gcase_summary?.short_description}</span>
                        </Grid>
                        ))
                    ) : (
                        <div className="w-100 d-flex justify-content-center mt-4">
                            <p>No data to display</p>
                        </div>
                    )}
                </Grid>
            </Grid>
        </>}
    </div>
  )
}

export default RaisedCasesSeekerComp
